import { useSimpleRole } from './use-simple-role';

export const useDeviceEditPermissions = () => {
  const { role, isSystemAdmin } = useSimpleRole();
  
  // Admin, editor, and superuser can edit device configurations
  // (editor is a standard user that an admin has granted edit rights to)
  const canEditDeviceConfig = role === 'admin' || role === 'editor' || isSystemAdmin;
  
  return {
    canEditDeviceConfig,
    isLoading: false, // useSimpleRole has internal loading handled by its cache
    userRole: role
  };
};
